package com.vizio.redwolf.consent.model

import kotlinx.serialization.Serializable
import kotlin.js.JsExport

@Serializable
@JsExport
data class ConsentReceiptResponse(
    val consentReceipt: String
)